var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex flex-row flex-align-center"},[_c('SIcon',{staticClass:"mr-1",attrs:{"height":"13","width":"11","name":"num-of-teams-saved"}}),_c('h5',{staticClass:"liked"},[_vm._v(_vm._s(_vm.numOfTeamsText)+" saved this")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }